import { CommonModule } from '@angular/common';
import { Component, input, computed } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-kiosk-product-overview-cart-atom',
  templateUrl: './kiosk-product-overview-cart-atom.component.html',
  styleUrls: ['./kiosk-product-overview-cart-atom.component.scss'],
  standalone: true,
  imports: [CommonModule, ContentBuilderColorPipe, TranslateModule],
})
export class KioskProductOverviewCartAtomComponent {
  readonly id = input.required<string | number>();
  readonly name = input.required<string>();
  readonly quantity = input.required<number>();
  readonly dotColor = input<IContentBuilderFieldColor>();
  readonly dotTextColor = input<IContentBuilderFieldColor>();
  readonly productBackgroundColor = input<IContentBuilderFieldColor>();
  readonly productTextColor = input<IContentBuilderFieldColor>();
  readonly thumbnail = input<string>();
  readonly isAvailable = input<boolean>(true);
  readonly hasProductToReplace = input<boolean>(false);

  readonly truncatedName = computed(() =>
    this.name()?.length > 13 ? `${this.name().slice(0, 13)}...` : this.name(),
  );
}
